import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FeatureFlagState = {
  isAdminFeatureEnabled: boolean | null;
};

const initialState: FeatureFlagState = {
  isAdminFeatureEnabled: null,
};

const featureFlagSlice = createSlice({
  name: 'featureFlag',
  initialState,
  reducers: {

    setIsAdminFeatureEnabled: (state, action: PayloadAction<boolean>) => {
      state.isAdminFeatureEnabled = action.payload;
    },
  }
});

export const { setIsAdminFeatureEnabled } = featureFlagSlice.actions;
export default featureFlagSlice.reducer;

